import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../Estilos/Estilo.scss'
class Footer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lineasInvestigacion: [],
			lineasInvestigacionShort: []
		}
	}
	render() {
		return (	  
			<div className="footer">
				<footer>
					<Row>
							<Col className="icons" sm={12}>
								{/* <div className="icons">*/}
						<div className="wrapper">
							
							<div className="iconUPM">
								<a href="https://portalcientifico.upm.es/es/ipublic/entity/16280" target="_blank" rel="noopener noreferrer" title="GRyS profile at UPM Scientific Portal">
									<img id="portalCientifico" src="assets/img/icons/upm-portal-cientifico.png" alt="GRyS profile at UPM's Scientific Portal" height="30"/>
								</a>
								<a href="https://www.upm.es/recursosidi/map/grupo-de-redes-y-servicios-de-proxima-generacion-grys/" target="_blank" rel="noopener noreferrer" title="GRyS profile at UPM Innovation Hub">
									<img  id="hubInnovacion"src="assets/img/icons/upm-hub.png" alt="GRyS profile at UPM's Innovation Hub" height="30"/>
								</a>
								<a href="http://www.upm.es/observatorio/vi/index.jsp?pageac=grupo.jsp&idGrupo=400" target="_blank" rel="noopener noreferrer" title="GRyS profile at UPM R+D Observatory">
									<img id="observatorioUPM" src="assets/img/icons/upm-observatorio.png" alt="GRyS profile at UPM's R+D Observatory" height="30"/>
								</a>
							</div>
						</div>
						  {/* </div> */}
							</Col>
					</Row>
					<Row>
						<div className="footerInfo">
							<div className='info'>
								
								<div className='AreasInv'>
									<a href='./inv-lines'><h4>Research Areas</h4></a>
									{this.setState({lineasInvestigacionShort:this.state.lineasInvestigacion.slice(0, 8)})}
									{this.state.lineasInvestigacionShort.map(({title, description, image, detailedDescription})=>{
										return(
											<tr> 
											&raquo;&nbsp;
											{title}</tr>
											
										);
									})}
								</div>
								<div className='contacto'>
									<h4>CONTACT</h4>
									<h5>mail: <a href='mailto:gi.grys@upm.es'>gi.grys@upm.es</a></h5><br/>
									<div className='contenedor'>
									<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d515.215986594536!2d-3.6287801689139667!3d40.38980684019983!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4225a6b24b1c2f%3A0x67193b511fdd5ff6!2sGrupo%20de%20Redes%20y%20Servicios%20de%20Pr%C3%B3xima%20Generaci%C3%B3n!5e1!3m2!1ses!2ses!4v1678697735524!5m2!1ses!2ses" width="200%" height="200%" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="myFrame"></iframe>
									</div>
								</div>
										
							</div>
							
						</div>
					</Row>
					<p className='copyright'>Grupo de Redes y Servicios de Próxima Generación (GRyS) &copy;  {new Date().getFullYear()}</p>
				</footer>
			</div>
		)
	}
	componentDidMount(){
		fetch(process.env.PUBLIC_URL+"/assets/json/research-areas.json").then(res=>res.json()).then(lineasInvestigacion=>this.setState({lineasInvestigacion, loading: false}));
		
	}
}


export default Footer;